import React, { useState } from "react";
import API from "../lib/api";
import { useTranslation } from "react-i18next";
import { Section } from "../components/Common";
import { toast } from "sonner";
import { errorMessage } from "../lib/errors";

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const [phase, setPhase] = useState("request");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");

  const request = async (e) => {
    e.preventDefault();
    try {
      const { data } = await API.post("/auth/password/request", { email });
      if (data?.reset_token) {
        setToken(data.reset_token);
        toast.success(t("auth.reset_token_dev_note"));
      } else toast.success(t("auth.reset_sent"));
      setPhase("reset");
    } catch (e) { toast.error(errorMessage(e, t("auth.reset_request_failed"))); }
  };

  const reset = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error(t("auth.password_min_short"));
    try {
      await API.post("/auth/password/reset", { token, new_password: pw });
      toast.success(t("auth.password_updated"));
      setPhase("done");
    } catch (e) { toast.error(errorMessage(e, t("auth.reset_failed"))); }
  };

  return (
    <Section eyebrow={t("auth.signup_eyebrow")} title={t("auth.reset_title")}>
      <div className="card-surface p-6 max-w-md" data-testid="reset-card">
        {phase === "request" && (
          <form onSubmit={request} className="grid gap-3">
            <input type="email" placeholder={t("auth.email")} value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0F1116] border border-white/10 rounded-lg px-4 py-3 text-sm" data-testid="reset-email" required />
            <button className="btn-primary text-sm" data-testid="reset-request">{t("auth.reset_generate")}</button>
          </form>
        )}
        {phase === "reset" && (
          <form onSubmit={reset} className="grid gap-3">
            <input value={token} onChange={(e) => setToken(e.target.value)} placeholder={t("auth.reset_token_placeholder")} className="bg-[#0F1116] border border-white/10 rounded-lg px-4 py-3 text-sm" data-testid="reset-token" required />
            <input type="password" placeholder={t("auth.new_password")} value={pw} onChange={(e) => setPw(e.target.value)} className="bg-[#0F1116] border border-white/10 rounded-lg px-4 py-3 text-sm" data-testid="reset-newpw" required />
            <button className="btn-primary text-sm" data-testid="reset-confirm">{t("auth.set_password")}</button>
          </form>
        )}
        {phase === "done" && <div className="text-emerald-300" data-testid="reset-done">{t("auth.password_updated_short")}</div>}
      </div>
    </Section>
  );
}
